import { type EWUser, type RawCalendarData, WarningEventType, WarningInCalendar } from './types';
import { restapi } from './restapi';
import { type HashMap } from '../utils/utils';
import { monthsDiff, type SimpleDate } from '../utils/SimpleDate';


export function getEWUser() {
	return restapi.get<EWUser>(`ew-user/`).then(res => res.data);
}

export function getRiskLabels() {
	return restapi.get<{ code: string, label: string }[]>(`risk/`).then(res => {
		const hash: HashMap = {};
		res.data.forEach(r => hash[r.code] = r.label);
		return hash;
	});
}

function compareForSort<T extends number | string>(a: T, b: T): (-1 | 0 | 1) {
	return (a < b) ? -1 : ((a > b) ? 1 : 0);
}

export function compareWarnings(a: WarningInCalendar, b: WarningInCalendar) {
	return compareForSort(a.rb, b.rb) || compareForSort(a.title, b.title) || compareForSort(a.id, b.id);
}

function parseCalendar(data: RawCalendarData[], from: SimpleDate, to: SimpleDate): WarningInCalendar[] {
	const n = 1 + monthsDiff(from, to);
	return data.map(w => {
		const wc = ({...w.warning, eventsCalendar: []}) as WarningInCalendar;
		const ec: typeof wc.eventsCalendar = Array(n).fill(null);  // n times null
		let raiseAt = -1;
		let closeAt = n;
		w.events.forEach(e => {
			const i = monthsDiff(from, e.date);
			if (ec[i]) {
				console.error('Too many events on the same month', w, ec[i], e);
			} else {
				ec[i] = e;
			}
			if (e.type === WarningEventType.raised) {
				raiseAt = i;
			}
			if (e.type === WarningEventType.closed) {
				closeAt = i;
			}
		});
		for (let i = raiseAt + 1; i < closeAt; i++) {
			if (!ec[i]) {
				ec[i] = true;  // true means available cell for new updates
			}
		}
		wc.eventsCalendar = ec;
		return wc;
	}).sort((a, b) => compareWarnings(a, b));
}

export function getCalendar(from: SimpleDate, to: SimpleDate) {
	const config = {
		params: {
			from: from,
			to: to,
		},
	};
	return restapi.get<RawCalendarData[]>(`calendar/`, config)
		.then(res => parseCalendar(res.data, from, to));
}

export function userCanEditWarnings(user: EWUser) {
	return user.canEdit || user.isSuperUser;
}
